import React, { useEffect, useState, useRef } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import "./dashboarsectionlayout.scss";

function DashboardSectionLayout() {
  const location = useLocation();
  console.log(location);
  const navigate = useNavigate();
  const prevPathRef = useRef(null);

  const [path, setPath] = React.useState("");
  const [btnName, setBtnName] = React.useState("");
  const [sectionTitle, setSectionTitle] = React.useState("");
  const [sectionDescription, setSectionDescription] = React.useState("");

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;
    }

    switch (location.pathname) {
      case "/dashboard/equipments":
        setPath("/dashboard/equipments/add-equipments");
        setBtnName("Add Equipment");
        setSectionTitle("Your Equipments");
        setSectionDescription(
          "Add details about your drones, cameras, and other gear."
        );
        break;
      case "/dashboard/certificates":
        setPath("/dashboard/certificates/add-certificate");
        setBtnName("Add Certification");
        setSectionTitle("Specialized Drone Certifications");
        setSectionDescription(
          "List any specialized certifications you hold related to drone operations."
        );
        break;
      case "/dashboard/licenses":
        setPath("/dashboard/licenses/add-license");
        setBtnName("Add License");
        setSectionTitle("Specialized Drone Licenses");
        setSectionDescription(
          "List any specialized licenses you hold related to drone operations."
        );
        break;
      case "/dashboard/kycdocuments":
        setPath("/dashboard/kycdocuments/add-kycdocument");
        setBtnName("Complete KYC Verification");
        setSectionTitle("KYC Verification");
        setSectionDescription(
          "Complete KYC verification to ensure the security of your account and build trust with clients."
        );
        break;

      case "/dashboard/services":
        setPath("/dashboard/services/add-services");
        setBtnName("Add Service");
        setSectionTitle("Add New Service");
        setSectionDescription(
          "Add, edit, and manage the drone services you offer to potential clients."
        );
        break;

      default:
        setPath("");
        setBtnName("");
        setSectionTitle("");
        setSectionDescription("");
        break;
    }
  }, [location.pathname]);

  const handleBack = () => {
    if (location.pathname.match(/^\/dashboard\/equipments\/[^/]+$/)) {
      prevPathRef.current = "/dashboard/equipments";
      navigate("/dashboard/equipments");
    } else if (location.pathname.match(/^\/dashboard\/licenses\/[^/]+$/)) {
      prevPathRef.current = "/dashboard/licenses";
      navigate("/dashboard/licenses");
    } else if (location.pathname.match(/^\/dashboard\/certificates\/[^/]+$/)) {
      // const certificateId = location.pathname.split("/").pop();
      // prevPathRef.current = `/dashboard/certificates/${certificateId}`;
      // navigate(`/dashboard/certificates/${certificateId}`);
      prevPathRef.current = "/dashboard/certificates";
      navigate("/dashboard/certificates");
    } else if (location.pathname.match(/^\/dashboard\/kycdocuments\/[^/]+$/)) {
      prevPathRef.current = "/dashboard/licenses";
      navigate("/dashboard/kycdocuments");
    } else if (location.pathname.match(/^\/dashboard\/services\/[^/]+$/)) {
      prevPathRef.current = "/dashboard/licenses";
      navigate("/dashboard/services");
    } else if (location.pathname === "/dashboard/equipments/add-equipments") {
      prevPathRef.current = "/dashboard/equipments";
      navigate("/dashboard/equipments");
    } else if (
      location.pathname === "/dashboard/certificates/add-certificate"
    ) {
      prevPathRef.current = "/dashboard/certificates";
      navigate("/dashboard/certificates");
    } else if (
      [
        "/dashboard/equipments",
        "/dashboard/certificates",
        "/dashboard/licenses",
        "/dashboard/kycdocuments",
        "/dashboard/services",
      ].includes(location.pathname)
    ) {
      prevPathRef.current = "/dashboard";
      navigate("/dashboard");
    } else {
      if (
        !prevPathRef.current ||
        prevPathRef.current === location.pathname ||
        window.history.length <= 1
      ) {
        navigate("/dashboard");
      } else {
        navigate(-1);
      }
    }
  };

  return (
    <div className="dashboard-section-layout">
      <div className="section-header">
        {!(
          location.pathname.includes("country-shots") ||
          location.pathname.includes("add-your-services") ||
          location.pathname.includes("review") ||
          location.pathname.includes("how-we-work") ||
          location.pathname.includes("contact-us") ||
          location.pathname.includes("about-us") ||
          location.pathname.includes("partner") ||
          location.pathname.includes("privacy-policy")
        ) && (
          <button onClick={handleBack} className="back-btn">
            <IoChevronBackCircleOutline />
          </button>
        )}
      </div>

      {sectionTitle && (
        <div className="section-info">
          <div className="center-content">
            <h2>{sectionTitle}</h2>
            <p>{sectionDescription}</p>
            {path && (
              <Link to={path} className="form-btn">
                {btnName}
              </Link>
            )}
          </div>
          <hr className="section-divider" />
        </div>
      )}

      <div className="section-body">
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardSectionLayout;